import wx from 'weixin-js-sdk'
import { shareConfig } from '../config/index'

const ShareConfig = {}
let isWxReady = false
const config = {
  lifehall: {
    title: '「KY生活哲学交友馆」',
    timelineTitle: '来「KY生活哲学交友馆」，找到那个灵魂共频的Ta，彼此照亮。',
    desc: '让我和你在浩瀚的星空中相遇，照亮彼此。',
    imgUrl: 'https://cdn-static.knowyourself.cc/activity_h5/lifehall/share_icon.jpg',
    link: `${window.location.origin}/lifehall`,
  },
}

function checkDefaultConfig(path) {
  /* eslint-disable */
  for (const { key, value } of config) {
    if (path.includes(key)) {
      return value
    }
  }
  return shareConfig
}

ShareConfig.install = (Vue, options) => {
  console.log(options)
  Vue.prototype.$setShare = (option) => {
    const {
      timelineTitle = '', title = '', imgUrl = '', link = window.location.href, onShare = () => { }, onShareCancel = () => {}, desc = '',
    } = option || checkDefaultConfig(this.$route.path)

    const doSet = () => {
      console.log(timelineTitle)
      // 逻辑...
      wx.onMenuShareTimeline({
        title: timelineTitle || title, // 分享标题
        link: `${link.includes('?') ? link : `${link}?`}&CKTAG=mtah5_share.pyq`, // 分享链接
        imgUrl, // 分享图标
        success() {
          // 用户确认分享后执行的回调函数
          onShare()
          window.MtaH5.clickShare('pyq')
        },
        cancel() {
          // 用户取消分享后执行的回调函数
          onShareCancel()
        },
      })

      wx.onMenuShareAppMessage({
        title, // 分享标题
        desc, // 分享描述
        link: `${link.includes('?') ? link : `${link}?`}&CKTAG=mtah5_share.hy`, // 分享链接
        imgUrl, // 分享图标
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success() {
          // 用户确认分享后执行的回调函数
          onShare()
          window.MtaH5.clickShare('hy')
        },
        cancel() {
          // 用户取消分享后执行的回调函数
          onShareCancel()
        },
      })

      wx.onMenuShareQQ({
        title, // 分享标题
        link, // 分享链接
        imgUrl, // 分享图标
        desc,
        success() {
          // 用户确认分享后执行的回调函数
          onShare()
        },
        cancel() {
          // 用户取消分享后执行的回调函数
          onShareCancel()
        },
      })

      wx.onMenuShareWeibo({
        title, // 分享标题
        link, // 分享链接
        imgUrl, // 分享图标
        desc,
        success() {
          // 用户确认分享后执行的回调函数
          onShare()
        },
        cancel() {
          // 用户取消分享后执行的回调函数
          onShareCancel()
        },
      })
    }

    if (!isWxReady) {
      wx.ready(() => {
        isWxReady = true
        doSet()
      })
      return
    }
    doSet()
  }
}

export default ShareConfig
